import React from "react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import { Box, Stack, Text } from "@chakra-ui/react"
import ConfigBlock from "pages/EventShow/Forms/StyleAndConfiguration/ConfigBlock"
import { DioboxEvent } from "sharedTypes"
import LanguageTemplateReference from "components/settings/LanguageTemplateReference"
import UrlWithRegenerateLink from "pages/EventShow/Forms/UrlWithRegenerateLink"
import ModalContentWrapper from "./ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const MapLinkModal = ({
  onHide,
  event: {
    portalShowMap,
    portalMapUrl,
  },
  event,
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const values = {
    portalShowMap,
    portalMapUrl,
  }

  const handleSubmit = async (data) => {
    await updateEvent(data)
    onHide()
  }

  const handleCancel = () => {
    onResetEventWorkingCopy()
    onHide()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={values}
      title="Map Link"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
    >
      {({ control, watch }) => {
        const mapEnabled = watch("portalShowMap")

        return (
          <ModalContentWrapper>
            <ConfigBlock title="Enabled" control={control} switchName="portalShowMap">
              <LanguageTemplateReference
                eventId={event.id}
                description={(resolvedName) => (
                  <Stack spacing={2}>
                    <Text>
                      The &quot;Map Link&quot; text uses the event language, currently
                      set to{" "}
                      <Text as="span" fontWeight="semibold">{resolvedName}</Text>.
                    </Text>
                    <Text>
                      Change it in{" "}
                      <Text as="span" fontWeight="semibold">
                        Event Settings → Language Templates
                      </Text>.
                    </Text>
                  </Stack>
                )}
              />
              <Box mb={3} mt={6}>
                <Text fontWeight="semibold" fontSize="lg">URL</Text>
              </Box>
              <UrlWithRegenerateLink control={control} event={event} mapEnabled={mapEnabled} />
            </ConfigBlock>
          </ModalContentWrapper>
        )
      }}
    </ModalForm>
  )
}

export default MapLinkModal
